"use strict";
import s from "underscore.string";
import _ from "underscore";
import { List, Map } from "immutable";
import formatRules from "./rules";
import generalFormatter from "./general";
import carrierFormatter from "./carriers";
import Api from "../api/api";
import {
  ActivityItemAccountsPayableActivityType
} from "../accounts_payable/data/types/Pb";
import { title, titleForType } from "./documents";
import { documentBatchPath } from "../accounts_payable/flow_mode/dashboard_paths";
function formatIgnore(item) {
  var formatted = {
    title: "Documents marked as ignored",
    link_text: item.data.subject,
    body: item.data.reason ? "Reason: " + item.data.reason : null
  };
  return withUser(item, formatted);
}
function formatStateChange(item) {
  return loadItem(
    item,
    "Load moved to " + item.data.new_state + " from " + item.data.original_state,
    void 0,
    [{ label: "Reason", value: item.data.reason }]
  );
}
function formatInvoiceSentToExternal(item) {
  var items = [];
  items.push({ label: "Recipient", value: item.data.url });
  items.push({ label: "Response", value: item.data.response });
  if (item.data.filename) {
    items.push({ label: "File Name", value: item.data.filename });
  }
  items.push({
    label: "Data",
    code: typeof item.data.payload === "string" ? item.data.payload : JSON.stringify(item.data.payload)
  });
  return loadItem(item, "Invoice Successfully Sent", void 0, items);
}
function formatDocumentSent(item) {
  var formatted = {
    title: "Document Sent",
    link_text: item.data.subject
  };
  var items = [];
  items.push({ label: "Document Type", value: item.data.document_type });
  if (item.data.load_id) {
    items.push({ label: "Load ID", value: item.data.load_id });
  }
  formatted.labeled_elements = items;
  return withUser(item, formatted);
}
function formatDocumentGroupIgnored(item) {
  var formatted = {
    title: "Document group marked as ignored",
    body: item.data && item.data.reason ? "Reason: " + item.data.reason : null
  };
  return withUser(item, formatted);
}
function formatEmailIgnored(item) {
  var formatted = {
    title: "Email marked as ignored",
    body: item.data.reason ? "Reason: " + item.data.reason : null
  };
  return withUser(item, formatted);
}
function formatEmailUnignored(item) {
  var formatted = { title: "Email Unignored by Admin" };
  return withUser(item, formatted);
}
function formatDuplicateEmailAutoCompleted(item) {
  var formatted = {
    title: "Duplicate Email Auto-Completed",
    body: item.data.duplicate_email_message_id ? "Duplicate Email Message ID: " + item.data.duplicate_email_message_id : null
  };
  return withUser(item, formatted);
}
function formatAutoCompletedWaitingExceptionsOnNewDocs(item) {
  var formatted = {
    title: "Invoice moved from Waiting to Ready to Audit due to new documents"
  };
  return withUser(item, formatted);
}
function formatDuplicateDocumentBatchAutoCompleted(item) {
  var formatted = {
    title: "Duplicate Document Batch Auto-Completed"
  };
  if (item.data.duplicate_document_batch_id) {
    formatted.labeled_elements = [
      {
        label: "Duplicate Document Batch ID",
        value: String(item.data.duplicate_document_batch_id),
        url: "/app" + documentBatchPath(item.data.duplicate_document_batch_id).toString(),
        newTab: true
      }
    ];
  }
  return withUser(item, formatted);
}
function formatLoadNotFound(item) {
  var formatted = { title: "'Load Not Found' exception created" };
  return withUser(item, formatted);
}
function formatRemoveDocumentGroupIgnored(item) {
  var formatted = { title: "Document group unignored" };
  return withUser(item, formatted);
}
function formatLoadNotFoundRemoved(item) {
  var formatted = { title: "'Load Not Found' exception removed" };
  return withUser(item, formatted);
}
function formatIndexingComplete(item) {
  var formatted = { title: "Indexing Complete" };
  return withUser(item, formatted);
}
function formatClientOrDebtorOnBOLChanged(item) {
  var formatted = {
    title: "Client or Debtor on BOL value changed to " + item.data.to
  };
  return withUser(item, formatted);
}
function formatInvoiceExceptionEmailSent(item) {
  var formatted = { title: "Email sent on exception" };
  return withUser(item, formatted);
}
function withUser(item, formatted) {
  if (item.user) {
    formatted.user_name = item.user.name || item.user.email;
  } else {
    formatted.user_name = item.automated_activity_display_name || "System";
  }
  return formatted;
}
function formatNote(item) {
  return loadItem(item, "Note Added", item.data.message);
}
function formatPaymentsNetworkNote(item) {
  return loadItem(
    item,
    "Note Sent to Payee via Payments Network",
    item.data.message
  );
}
function formatTransmissionFailed(item) {
  const labeled = [
    { label: "Failure Message", value: item.data.failure_message }
  ];
  return loadItem(item, "Invoice Rejected by TMS", void 0, labeled);
}
function formatTransmissionSucceeded(item) {
  return loadItem(item, "Invoice transmission succeeded");
}
function formatTransmissionReceived(item) {
  return loadItem(item, "Invoice transmission received");
}
function formatDocumentsMerged(item) {
  return loadItem(
    item,
    "Documents Merged",
    "Documents of the same type were merged while sending customer invoice to the payments network",
    void 0
  );
}
function formatEmail(item) {
  var direction = item.data.direction === "sent" ? "Sent" : "Received";
  var labeled = [
    { label: "Sender", value: item.data.sender_address },
    { label: "Recipient", value: item.data.recipient_address }
  ];
  return loadItem(
    item,
    "Email " + direction + ': "' + item.data.subject + '"',
    item.data.text_body,
    labeled
  );
}
function formatEmailMergeTarget(item) {
  var formatted = {};
  var title2 = "Email created by merge";
  formatted.title = title2;
  formatted.user_name = item.data.user;
  formatted.labeled_elements = item.data.sources.map((source) => {
    return {
      label: "Source",
      value: source.subject,
      url: "/index-document-batches/" + source.document_batch_id
    };
  });
  return formatted;
}
function formatEmailMergeSource(item) {
  var formatted = {};
  var title2 = "Email was merged";
  formatted.title = title2;
  formatted.user_name = item.data.user;
  formatted.labeled_elements = [
    {
      label: "New Message",
      value: "View",
      url: "/index-document-batches/" + item.data.target_document_batch_id
    }
  ];
  return formatted;
}
function formatException(item) {
  const word = Api.Account.current().factor_account ? "Incomplete" : "Exception";
  return loadItem(item, "Saved As " + word);
}
function formatInvoiceRejected(item) {
  return loadItem(item, "Processed Invoice Rejected");
}
function formatSentToVerifyQueue(item) {
  return loadItem(item, "Invoice sent to verify queue");
}
function formatVerifyCompleted(item) {
  const note = item.data.note ? [{ label: "Note", value: item.data.note }] : [];
  return loadItem(
    item,
    "Invoice verification completed: " + item.data.status,
    void 0,
    note
  );
}
function formatBypassedVerifyQueue(item) {
  return withUser(item, { title: "Invoice bypassed verify queue." });
}
function formatMarkedNotReadyForVerification(item) {
  return withUser(item, { title: "Marked not ready for Verification" });
}
function formatVerifierChangedInvoiceAmount(item) {
  const oldAmount = generalFormatter.currency(item.data.old_amount);
  const newAmount = generalFormatter.currency(item.data.new_amount);
  return withUser(item, {
    title: `Changed invoice amount during verification from ${oldAmount} to ${newAmount}`
  });
}
function formatSentToCadence(item) {
  return loadItem(item, "Invoice Sent To CADENCE");
}
function formatVerifiedByCadence(item) {
  return loadItem(item, "Invoice Successfully Received By CADENCE");
}
function formatReadyForFMSPickup(item) {
  return loadItem(item, "Invoice Ready for FMS Pickup");
}
function formatAcknowledgedByFMS(item) {
  return loadItem(item, "Invoice Acknowledged by FMS");
}
function formatExceptionResolved(item) {
  return loadItem(
    item,
    'Exception: "' + item.data.message + '" resolved',
    "Resolution: " + (item.data.resolution || "Not Provided")
  );
}
function formatExternalCreation(item) {
  var items = [];
  if (item.data && item.data.invoice) {
    var invoice = item.data.invoice;
    items.push({ label: "Invoice Number", value: invoice.invoice_number });
    items.push({
      label: "Amount",
      value: generalFormatter.currency(invoice.amount_to_pay)
    });
    if (invoice.invoice_date) {
      items.push({
        label: "Invoice Date",
        value: generalFormatter.shortDate(invoice.invoice_date)
      });
    }
    items.push({
      label: "Date to Pay",
      value: generalFormatter.shortDate(invoice.date_to_pay)
    });
    if (invoice.carrier_id) {
      items.push({
        label: "Carrier",
        value: carrierFormatter.nameAndInfoForId(invoice.carrier_id)
      });
    }
  }
  return loadItem(
    item,
    "Invoice Created From " + s.capitalize(item.data.invoice.source_system),
    void 0,
    items
  );
}
function formatProcessed(item) {
  var items = [];
  if (item.data && item.data.invoice) {
    var invoice = item.data.invoice;
    items.push({ label: "Invoice Number", value: invoice.invoice_number });
    items.push({
      label: "Amount",
      value: generalFormatter.currency(invoice.amount_to_pay)
    });
    if (invoice.invoice_date) {
      items.push({
        label: "Invoice Date",
        value: generalFormatter.shortDate(invoice.invoice_date)
      });
    }
    items.push({
      label: "Date to Pay",
      value: generalFormatter.shortDate(invoice.date_to_pay)
    });
    if (invoice.carrier_id) {
      items.push({
        label: "Carrier",
        value: carrierFormatter.nameAndInfoForId(invoice.carrier_id)
      });
    }
    if (invoice.remit_to_address) {
      items.push({
        label: "Remit To",
        value: formatAddress(invoice.remit_to_address)
      });
    }
  } else if (item.data && item.data.factor_invoice) {
    const invoice2 = item.data.factor_invoice;
    items.push({ label: "Invoice Number", value: invoice2.invoice_number });
    if (invoice2.load_id) {
      items.push({ label: "Load ID", value: invoice2.load_id });
    }
    items.push({
      label: "Amount",
      value: generalFormatter.currency(invoice2.amount)
    });
    if (invoice2.invoice_date) {
      items.push({
        label: "Invoice Date",
        value: generalFormatter.shortDate(invoice2.invoice_date)
      });
    }
    items.push({
      label: "Carrier",
      value: carrierFormatter.nameAndInfoForId(invoice2.carrier_id)
    });
    if (invoice2.carrier_id) {
      items.push({ label: "Debtor", value: invoice2.debtor_name });
    }
  }
  var title2 = item.activity_type === "auto_processed" ? "Invoice Auto Processed" : "Invoice Processed";
  return loadItem(item, title2, void 0, items);
}
function formatFlaggedForManualReviewReason(reason) {
  switch (reason) {
    case "hit_client_threshold":
      return "Randomly Selected for Review Based on Client Setting";
    case "hit_account_threshold":
      return "Randomly Selected for Review Based on Account Setting";
    case "failed_auto_verification":
      return "Auto Verification Failed";
  }
}
function formatFlaggedForManualReview(item) {
  return loadItem(
    item,
    "Auto Processable Invoice Has Been Flagged for Manual Review",
    void 0,
    [
      {
        label: "Reason",
        value: formatFlaggedForManualReviewReason(item.data.reason)
      }
    ]
  );
}
function formatLoadShipmentApproved(item) {
  var items = [];
  if (item.data) {
    items.push({ label: "Shipment ID", value: item.data.shipment_id });
    items.push({
      label: "Amount",
      value: generalFormatter.currency(item.data.amount || 0)
    });
    items.push({ label: "Customer ID", value: item.data.customer_id });
    items.push({ label: "Customer Name", value: item.data.customer_name });
  }
  return loadItem(item, "Shipment Approved", void 0, items);
}
function formatLoadShipmentUnapproved(item) {
  var items = [];
  if (item.data) {
    items.push({ label: "Shipment ID", value: item.data.shipment_id });
    items.push({
      label: "Amount",
      value: generalFormatter.currency(item.data.amount || 0)
    });
    items.push({ label: "Customer ID", value: item.data.customer_id });
    items.push({ label: "Customer Name", value: item.data.customer_name });
  }
  return loadItem(item, "Shipment Un-Approved", void 0, items);
}
function formatUpdatedFromExternal(item) {
  const data = item.data;
  const items = [
    { label: "Updated Attribute", value: data.updated_attribute },
    { label: "Previous Value", value: data.previous_value },
    { label: "New Value", value: data.new_value }
  ];
  return loadItem(item, "Invoice Updated From TMS", void 0, items);
}
function formatApproval(item) {
  return loadItem(item, "Invoice Approved");
}
function formatCarrierPayableApproval(item) {
  const items = (() => {
    if (item.data != null) {
      const invoice = item.data.invoice;
      return [
        { label: "Invoice Number", value: invoice.invoice_number },
        {
          label: "Amount",
          value: generalFormatter.currency(invoice.amount_to_pay || 0)
        },
        {
          label: "Invoice Date",
          value: generalFormatter.shortDate(invoice.invoice_date)
        },
        {
          label: "Date to Pay",
          value: generalFormatter.shortDate(invoice.date_to_pay)
        },
        {
          label: "Carrier",
          value: carrierFormatter.nameAndInfoForId(invoice.carrier_id)
        },
        { label: "Remit To", value: formatAddress(invoice.remit_to_address) }
      ];
    } else return [];
  })();
  return loadItem(item, "Carrier Payable Approved", void 0, items);
}
function formatDocumentsResendRequest(item) {
  return loadItem(item, "Invoice Documents Resend Requested");
}
function formatAbandoned(item) {
  const message = "Reason: " + (item.data.reason || "Not Provided");
  return loadItem(item, "Invoice Ignored", message);
}
function formatRemoved(item) {
  return loadItem(item, "Invoice Removed From Group");
}
function formatUnapproved(item) {
  return loadItem(item, "Invoice Un-Approved");
}
function formatRevived(item) {
  return loadItem(item, "Invoice Revived");
}
function formatReceivedInvoice(item) {
  return loadItem(item, "Indexed documents sent to TMS");
}
function formatRuleDisabled(item) {
  return loadItem(
    item,
    "Rule Disabled: " + formatRules.ruleAsPlainText(item.data.rule)
  );
}
function formatRuleEnabled(item) {
  return loadItem(
    item,
    "Rule Enabled: " + formatRules.ruleAsPlainText(item.data.rule)
  );
}
function formatPause(item) {
  return loadItem(
    item,
    "Load paused until " + generalFormatter.shortDate(item.data.paused_until)
  );
}
function formatDocumentAdded(item) {
  var items = [];
  if (item.data.original_load_state_id) {
    items.push({
      label: "Original Load",
      value: item.data.original_load_id,
      url: "/loads/" + item.data.original_load_state_id
    });
  }
  var documentType = title({ type: item.data.document_type });
  if (item.data.document_type_name) {
    documentType = item.data.document_type_name;
  }
  return loadItem(item, documentType + " added to invoice", void 0, items);
}
function formatDocumentRemoved(item) {
  var items = [
    {
      label: "New Load",
      value: item.data.new_load_id,
      url: "/loads/" + item.data.new_load_state_id
    }
  ];
  var documentType = title({ type: item.data.document_type });
  if (item.data.document_type_name) {
    documentType = item.data.document_type_name;
  }
  return loadItem(
    item,
    documentType + " removed from invoice",
    void 0,
    items
  );
}
function isEmptyObject(object) {
  return Object.values(object).every((x) => x === null || x === "");
}
function formatAddress(address) {
  if (!address || isEmptyObject(address)) {
    return "";
  }
  return (address.address_line_1 ? address.address_line_1 : "") + (address.address_line_2 ? ", " + address.address_line_2 : "") + (address.city ? ", " + address.city : "") + (address.state ? " " + address.state : "") + (address.postal_code ? " " + address.postal_code : "") + (address.country ? " " + address.country : "");
}
function formatPaymentAddressChanged(item) {
  var items = [];
  items.push({
    label: "Original Address",
    value: formatAddress(item.data.original_address)
  });
  items.push({
    label: "New Address",
    value: formatAddress(item.data.new_address)
  });
  var formatted = { labeled_items: items, title: "Payment Address Changed" };
  return withUser(item, formatted);
}
function formatForwardedEmail(item) {
  var formatted = {};
  var title2 = "Email was forwarded";
  if (item.data && item.data.recipients) {
    var recipients = s.toSentenceSerial(item.data.recipients);
    title2 = title2 + " to " + recipients;
  }
  formatted.title = title2;
  formatted.user_name = item.data.user;
  formatted.labeled_elements = [{ label: "Note", value: item.data.note }];
  return formatted;
}
function formatForwardedInvoiceDocumentsToTriumph(item) {
  var formatted = {};
  formatted.title = "Invoice Documents Forwarded To Triumph";
  if (item.user) {
    formatted.user_name = item.user.name || item.user.email;
  } else {
    formatted.user_name = item.automated_activity_display_name || "System";
  }
  return formatted;
}
function formatFactorInvoiceMatched(item) {
  return loadItem(item, "Documents matched to incomplete invoice");
}
function formatFactorInvoiceMarkedAsPurchased(item) {
  return loadItem(item, "Invoice Marked as Purchased");
}
function formatNonInvoiceLoadAssignment(item) {
  var formatted = {};
  var title2 = "Customer Documents assigned to load";
  formatted.title = title2;
  if (item.user) {
    formatted.user_name = item.user.name || item.user.email;
  } else {
    formatted.user_name = item.automated_activity_display_name || "System";
  }
  formatted.labeled_elements = [
    { label: "Load ID", value: item.data.load_id || "(Unknown)" }
  ];
  return formatted;
}
function formatExceptionsClearedViaAPI(item) {
  var formatted = { title: "Exceptions cleared via API" };
  return withUser(item, formatted);
}
function formatExceptionDocumentsSent(item) {
  var formatted = { title: "Exception documents sent" };
  return withUser(item, formatted);
}
function formatShipmentApproved(item) {
  return withUser(item, {
    title: "Shipment Approved",
    labeled_elements: [{ label: "VIN", value: item.data.vin }]
  });
}
function formatShipmentRejected(item) {
  return withUser(item, {
    title: "Shipment Rejected",
    labeled_elements: [
      { label: "VIN", value: item.data.vin },
      { label: "Reason", value: item.data.reason || "" }
    ]
  });
}
function formatLtlDispute(item) {
  const capitalize = ([firstLetter, ...restOfWord]) => firstLetter.toUpperCase() + restOfWord.join("");
  const disputeItems = item.data.disputeItems;
  const groupedItems = _.groupBy(
    disputeItems,
    (disputeItem) => disputeItem.reconcileType
  );
  const details = _.keys(groupedItems).map((key) => {
    const description = _.map(
      groupedItems[key],
      ({ description: description2 }) => description2
    );
    const formattedDescriptions = s.toSentenceSerial(description);
    return {
      value: `${capitalize(key)} disputed for ${formattedDescriptions}`
    };
  });
  return withUser(item, {
    title: "Invoice reconciliation action taken",
    labeled_elements: details
  });
}
function formatAddDocumentToLoadSuccess(item) {
  const data = item.data;
  const docTypes = data.documents.map(
    (doc) => titleForType(doc.documentType, "Unknown")
  );
  const sentence = s.toSentenceSerial(docTypes);
  return withUser(item, {
    title: "Load documents uploaded",
    labeled_elements: [{ value: `${sentence} uploaded` }]
  });
}
function formatAddDocumentToLoadFailure(item) {
  return withUser(item, {
    title: "Documents failed to upload"
  });
}
function formatLtlAccept(item) {
  const data = item.data;
  const details = data.acceptItems.flatMap(formatAcceptItem);
  return withUser(item, {
    title: "Weight / Class / Amount changed and re-rate initiated",
    labeled_elements: details
  });
}
function formatAcceptItem(item) {
  var _a, _b, _c, _d, _e, _f;
  function withLabel(label, value) {
    if (!value) {
      return null;
    }
    return { value, label };
  }
  return [
    { value: `${item.description}:` },
    withLabel("Original Class", (_a = item.classChange) == null ? void 0 : _a.original),
    withLabel("Updated Class", (_b = item.classChange) == null ? void 0 : _b.updated),
    withLabel("Original Weight", (_c = item.weightChange) == null ? void 0 : _c.original),
    withLabel("Updated Weight", (_d = item.weightChange) == null ? void 0 : _d.updated),
    withLabel("Original Amount", (_e = item.amountChange) == null ? void 0 : _e.original),
    withLabel("Updated Amount", (_f = item.amountChange) == null ? void 0 : _f.updated)
  ].filter(nonNull);
}
function nonNull(item) {
  return !!item;
}
function formatLtlInvoiceMovedToTmsQueue(item) {
  const title2 = "Invoice moved to TMS";
  const data = item.data;
  return withUser(item, {
    title: title2,
    labeled_elements: [
      { label: "Queue Name", value: data.queueName },
      { label: "Reason", value: data.reason }
    ]
  });
}
function formatLtlUpdatedEdiReceived(item) {
  const title2 = "An updated EDI was received";
  return withUser(item, { title: title2 });
}
function formatHidden(item) {
  return withUser(item, {
    title: item.data.message
  });
}
function formatLtlRerateRequested(item) {
  return withUser(item, {
    title: "Re-Rate Requested"
  });
}
function formatCarrierInvoiceRuleChangedViaTms(item) {
  return withUser(item, {
    title: "Invoice rule resolved by TMS update"
  });
}
function formatLtlRerateCompleted(item) {
  return withUser(item, {
    title: "Re-Rate Completed"
  });
}
function formatLtlRerateFailed(item) {
  return withUser(item, {
    title: "Re-Rate Failed",
    labeled_elements: [
      { label: "Error Message", value: item.data.error_message }
    ]
  });
}
function loadItem(item, title2, body = null, labeledElements = null) {
  var load = void 0;
  var loadId = "";
  if (load) {
    loadId = load.load.load_id;
  }
  var formatted = {
    url: loadUrl(item),
    link_text: loadId,
    title: title2,
    body,
    labeled_elements: labeledElements
  };
  if (item.user) {
    formatted.user_name = item.user.name || item.user.email;
  } else {
    formatted.user_name = item.automated_activity_display_name || "System";
  }
  formatted.user_id = item.user_id;
  return formatted;
}
function loadUrl(item) {
  return "/loads/" + item.owner_id;
}
const activityTypes = {};
const defineActivity = (id, name, formatter) => activityTypes[id] = Map({ name, formatter, id });
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeTransmissionReceived,
  "Invoice transmission received",
  formatTransmissionReceived
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeTransmissionFailed,
  "Invoice Rejected by TMS",
  formatTransmissionFailed
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeTransmissionSucceeded,
  "Invoice transmission succeeded",
  formatTransmissionSucceeded
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeStateChange,
  "State Changed",
  formatStateChange
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeException,
  "Saved As Incomplete",
  formatException
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeExceptionResolved,
  "Exception Resolved",
  formatExceptionResolved
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeInvoiceRejected,
  "Processed Invoice Rejected",
  formatInvoiceRejected
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypePause,
  "Paused",
  formatPause
);
defineActivity("email", "Email Sent/Received", formatEmail);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeIgnore,
  "Documents Ignored",
  formatIgnore
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeExternalCreation,
  "Invoice Created from TMS",
  formatExternalCreation
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeProcessed,
  "Invoice Processed",
  formatProcessed
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeAutoProcessed,
  "Invoice Auto Processed",
  formatProcessed
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeFlaggedForManualReview,
  "Auto Processable Invoice Has Been Flagged for Manual Review",
  formatFlaggedForManualReview
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeLoadShipmentApproval,
  "Shipment Approved",
  formatLoadShipmentApproved
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeLoadShipmentUnapproval,
  "Shipment Un-Approved",
  formatLoadShipmentUnapproved
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeApproval,
  "Invoice Approved",
  formatApproval
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeCarrierPayableApproval,
  "Carrier Payable Approved",
  formatCarrierPayableApproval
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeReceivedInvoice,
  "Indexed documents sent to TMS",
  formatReceivedInvoice
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeDocumentsResendRequested,
  "Invoice Documents Resend Requested",
  formatDocumentsResendRequest
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeInvoiceAbandoned,
  "Invoice Ignored",
  formatAbandoned
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeSentToCadence,
  "Sent To CADENCE",
  formatSentToCadence
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeReadyForFMSPickup,
  "Invoice Ready for FMS Pickup",
  formatReadyForFMSPickup
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeVerifiedByCadence,
  "Invoice Successfully Received By CADENCE",
  formatVerifiedByCadence
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeAcknowledgedByFMS,
  "Invoice Acknowledged by FMS",
  formatAcknowledgedByFMS
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeRemovedFromGroup,
  "Invoice Removed From Group",
  formatRemoved
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeInvoiceRevived,
  "Invoice Unignored",
  formatRevived
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeInvoiceUnapproved,
  "Invoice Un-Approved",
  formatUnapproved
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeRuleDisabled,
  "Exception Ignored",
  formatRuleDisabled
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeRuleEnabled,
  "Exception Unignored",
  formatRuleEnabled
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeNote,
  "Note Added",
  formatNote
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeSendNoteToPayeeViaPaymentsNetwork,
  "Note Sent to Payee via Payments Network",
  formatPaymentsNetworkNote
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeDocumentAdded,
  "Document Added",
  formatDocumentAdded
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeDocumentRemoved,
  "Document Removed",
  formatDocumentRemoved
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypePaymentAddressChanged,
  "Payment Address Changed",
  formatPaymentAddressChanged
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeForwardedEmail,
  "Email Forwarded",
  formatForwardedEmail
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeInvoiceDocumentsForwardedToTriumph,
  "Invoice Documents Forwarded To Triumph ",
  formatForwardedInvoiceDocumentsToTriumph
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeSentToExternal,
  "Invoice Sent to TMS",
  formatInvoiceSentToExternal
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeInvoiceMatched,
  "Invoice Matched",
  formatFactorInvoiceMatched
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeMarkedPurchasedByUser,
  "Invoice Marked As Purchased",
  formatFactorInvoiceMarkedAsPurchased
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeDocSentToExternal,
  "Document Sent",
  formatDocumentSent
);
defineActivity(
  "document_group_ignored",
  "Document Group Ignored",
  formatDocumentGroupIgnored
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeEmailIgnored,
  "Email Ignored",
  formatEmailIgnored
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeEmailUnignored,
  "Email Unignored",
  formatEmailUnignored
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeEmailZeroPages,
  "Email Zero Pages",
  formatEmailIgnored
);
defineActivity("load_not_found", "Load Not Found", formatLoadNotFound);
defineActivity(
  "remove_document_group_ignored",
  "Document Group Unignored",
  formatRemoveDocumentGroupIgnored
);
defineActivity(
  "load_not_found_removed",
  "Load Not Found Removed",
  formatLoadNotFoundRemoved
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeEmailMergeSource,
  "Email was merged",
  formatEmailMergeSource
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeEmailMergeTarget,
  "Email created by merge",
  formatEmailMergeTarget
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeNonInvoiceLoadAssignment,
  "Customer Documents Assigned to load",
  formatNonInvoiceLoadAssignment
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeExceptionsClearedViaAPI,
  "Exceptions cleared via API",
  formatExceptionsClearedViaAPI
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeUpdatedFromExternal,
  "Updated From External System",
  formatUpdatedFromExternal
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeDocsSentOnException,
  "Exception documents sent",
  formatExceptionDocumentsSent
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeAcertusShipmentApproved,
  "Shipment Approved",
  formatShipmentApproved
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeAcertusShipmentRejected,
  "Shipment Rejected",
  formatShipmentRejected
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeSentToVerifyQueue,
  "Invoice sent to verify queue",
  formatSentToVerifyQueue
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeVerifyCompleted,
  "Invoice verification completed",
  formatVerifyCompleted
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeBypassedVerifyQueue,
  "Invoice bypassed verify queue...",
  formatBypassedVerifyQueue
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeMarkedNotReadyForVerification,
  "Marked not ready for Verification",
  formatMarkedNotReadyForVerification
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeVerifierChangedInvoiceAmount,
  "Invoice amount changed during verification",
  formatVerifierChangedInvoiceAmount
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeIndexingComplete,
  "Indexing Complete",
  formatIndexingComplete
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeClientOrDebtorOnBolChanged,
  "Client or Debtor on BOL value changed",
  formatClientOrDebtorOnBOLChanged
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeInvoiceExceptionEmailSent,
  "Email sent on exception",
  formatInvoiceExceptionEmailSent
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeLtlDisputeAdded,
  "A dispute was initiated",
  formatLtlDispute
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeLtlAcceptAdded,
  "Weight / Class / Amount changed and re-rate initiated",
  formatLtlAccept
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeLtlUpdatedEdiReceived,
  "An updated EDI was received",
  formatLtlUpdatedEdiReceived
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeLtlMovedToTMSQueue,
  "Invoice moved to TMS",
  formatLtlInvoiceMovedToTmsQueue
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeHidden,
  "Document Duplicate toggled",
  formatHidden
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeDocumentsMerged,
  "Documents Merged",
  formatDocumentsMerged
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeAddDocumentToLoadSuccess,
  "Load documents uploaded",
  formatAddDocumentToLoadSuccess
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeAddDocumentToLoadFailure,
  "Documents failed to upload",
  formatAddDocumentToLoadFailure
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeLtlRerateRequested,
  "Re-Rate Requested",
  formatLtlRerateRequested
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeCarrierInvoiceRuleChangedViaTMS,
  "Invoice rule resolved by TMS update",
  formatCarrierInvoiceRuleChangedViaTms
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeLtlRerateCompleted,
  "Re-Rate Completed",
  formatLtlRerateCompleted
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeLtlRerateFailed,
  "Re-Rate Failed",
  formatLtlRerateFailed
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeDuplicateEmailAutoCompleted,
  "Duplicate Email Auto-Completed",
  formatDuplicateEmailAutoCompleted
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeAutoCompletedWaitingExceptionsOnNewDocs,
  "Invoice moved from Waiting to Ready to Audit due to new documents",
  formatAutoCompletedWaitingExceptionsOnNewDocs
);
defineActivity(
  ActivityItemAccountsPayableActivityType.ActivityItemAccountsPayableActivityTypeDuplicateDocumentBatchAutoCompleted,
  "Duplicate Document Batch Auto-Completed",
  formatDuplicateDocumentBatchAutoCompleted
);
export default {
  activityTypeMap: activityTypes,
  activityTypes: List(_.values(activityTypes)),
  format: function(item) {
    const entry = activityTypes[item.activity_type];
    if (entry) {
      return entry.get("formatter")(item);
    } else {
      return {
        title: item.activity_type
      };
    }
  }
};
